import { render, staticRenderFns } from "./client_space_login_logos.vue?vue&type=template&id=704f4232&scoped=true"
import script from "./client_space_login_logos.vue?vue&type=script&lang=js"
export * from "./client_space_login_logos.vue?vue&type=script&lang=js"
import style0 from "./client_space_login_logos.vue?vue&type=style&index=0&id=704f4232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704f4232",
  null
  
)

export default component.exports